export const t = (s: string): string => s;
